import React from 'react'
import cx from 'classnames'
import Icon from 'components/common/Icon'
import { Dropdown } from 'components/common/Dropdown/Dropdown'

type KebabAnchorProps = {
  className?: string
  isActive?: boolean
  onClick?: React.MouseEventHandler<HTMLElement>
}

export const KebabAnchor = React.forwardRef<HTMLSpanElement, KebabAnchorProps>(
  ({ className, isActive, ...props }, ref) => (
    <span
      className={cx('Action small', { active: isActive })}
      ref={ref}
      {...props}
    >
      <span className={'icon'}>
        <Icon name="kebab" />
      </span>
    </span>
  ),
)

type KebabActionProps = Omit<React.ComponentProps<typeof Dropdown>, 'Anchor'>

const KebabAction = ({ children, ...props }: KebabActionProps) => (
  <Dropdown Anchor={KebabAnchor} {...props}>
    <div className="kebabmenu">{children}</div>
  </Dropdown>
)

export default KebabAction
